import React from 'react';
import { inject, observer } from 'mobx-react';
import './index.scss'
// import {toJS} from 'mobx';


@inject('internal')
@inject('translate')
@observer
export default class NotFound extends React.Component {
    render() {
        return(
            <div className={'not_found'}>
                <p>{this.props.translate.i18n.GLOBAL.NOT_FOUND.PAGE}</p>
                <a href="/">{this.props.translate.i18n.GLOBAL.NOT_FOUND.HOME_BUTTON}</a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/not_found/index.js